import type { EmptyViewProps } from "./EmptyView";
import type { ListItem } from "./ItemList";
import ItemList from "./ItemList";
import OnboardingLayout from "./OnboardingLayout";

type Props = {
	handleNext: () => void;
	selectedStateCode?: string;
	handleSelectState: (stateCode: string) => void;
	items: ListItem[];
	handleSearchState?: (query: string) => void;
	searchQuery: string;
	selectedStateName?: string;
	emptyState?: EmptyViewProps;
	cta?: string;
};

const ChooseStateScreen = ({
	handleNext,
	selectedStateCode,
	handleSelectState,
	items,
	handleSearchState,
	searchQuery,
	selectedStateName,
	emptyState,
	cta = "Continue",
}: Props) => {
	const showSearch = items.length > 5;
	return (
		<OnboardingLayout
			onPrimaryPress={handleNext}
			disabled={!selectedStateCode}
			primaryActionLabel={cta}
			selectedItemText={selectedStateName}
			selectedItemLabel="Selected state"
			onSearchChange={showSearch ? handleSearchState : undefined}
			searchbarProps={{
				value: searchQuery,
				placeholder: "Search your state",
			}}
			containerPaddingVertical={0}
		>
			<ItemList
				items={items}
				onSelect={handleSelectState}
				selectedId={selectedStateCode}
				emptyState={emptyState}
			/>
		</OnboardingLayout>
	);
};

export default ChooseStateScreen;
